<template>
    <div style="padding: 20px">

        <div class="tip">
          <p>选择已设定的订单分组，设置订单审核规则，实现不同订单不同处理，不符合审核规则的订单自动判断为异常订单，异常订单将通过人工审核处理。多个审核规则按照权重的优先级处理。</p>
        </div>

        <!--按钮-->
        <div>
            <el-button class="mybtn-blue2" style="width: 100px" @click="showAddDialog()">新增</el-button>
        </div>

        <!--标题-->
        <div class="config-title">订单审核规则</div>

        <!--表格-->
        <el-table :data="main$data" v-loading="main$loading" size="medium">
            <el-table-column type="index" label="序号" width="50" align="center" header-align="center"> </el-table-column>
            <el-table-column prop="name" label="规则名称" width="180" align="center" header-align="center"> </el-table-column>
            <el-table-column prop="groups" label="适用订单分组" width="220" align="center" header-align="center"> </el-table-column>
            <el-table-column prop="description" label="说明" width="260" align="center" header-align="center"> </el-table-column>
            <el-table-column prop="states" label="状态" width="100" align="center" header-align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.states == '0'">停用</span>
                    <span v-else-if="scope.row.states == '1'" style="color: #29CF87">启用</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" header-align="center">
                <template slot-scope="scope">
                    <el-button type="text" @click="table_update(scope.row)">修改</el-button>
                    <el-button type="text" @click="table_delete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--dialog 新增、编辑-->
        <el-dialog :title="editDialogType=='add'?'新增订单审核规则':'编辑订单审核规则'"
                   :visible.sync="editDialogVisible"
                   class="mydialog mydialog_add_order_audit_rule"
                   :append-to-body="true">
            <el-form :label-position="'right'" label-width="90px" class="myform">
                <input type="hidden" v-model="editData.id">
                <!--/-->
                <el-form-item label="规则名称：">
                    <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.name"></el-input>
                </el-form-item>
                <!--/-->
                <el-form-item label="订单分组：">
                    <div>选择已设定订单分组</div>
                    <el-checkbox-group v-model="editData.groupRule">
                        <el-checkbox v-for="(item,item_idx) in data_orderGroup" :key="item_idx"
                                     :label="item.id+''"
                                     :disabled="isGroupRuleDis(item.name,editData.id)">{{item.name}}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <!--/-->
                <el-form-item label="规则设置：">
                  <el-select size="small" value="选择规则" v-model="editData.OrderAuditType" @change="selectRule">
                    <el-option v-for="(item,item_idx) in data_OrderAuditType" :key="item_idx"
                               :label="item.value" :value="item.code"></el-option>
                  </el-select>
                  <!----------------规则 START---------------->
                  <div v-for="(item,item_idx) in data_OrderAuditType" :key="item_idx">
                    <div v-if="item.code=='01'">
                        <!--商品价格-->
                        <div v-if="editData['r_show_'+item.code]">
                            <div>
                                <span class="subtitle">商品价格</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                                <!--/-->
                                <p></p>
                                <el-checkbox label="允许不按默认原价执行" v-model="editData.rules['01']['01'].allowYes" @change="allowChange('01','01','yes')"></el-checkbox>
                                <el-checkbox label="按默认原价执行" v-model="editData.rules['01']['01'].allowNo" @change="allowChange('01','01','no')"></el-checkbox>
                                <br>
                                <!--/-->
                                <div v-if="editData.rules['01']['01'].allowNo">
                                    <!--/-->
                                    <el-checkbox label="优先按客户上次成交价执行" v-model="editData.rules['01']['02'].checked"></el-checkbox><br/>
                                    <!--/-->
                                    <!--<el-checkbox label="允许低于默认销售价格" v-model="editData.rules['01']['03'].checked"></el-checkbox><br/>-->
                                    <!--<div v-if="editData.rules['01']['03'].checked">-->
                                      <!--<p style="color: #999">差价范围</p>-->
                                      <!--<el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.rules['01']['03'].val"></el-input>-->
                                    <!--</div>-->
                                    <!--/-->
                                    <!--<el-checkbox label="允许高于默认销售价格" v-model="editData.rules['01']['04'].checked"></el-checkbox><br/>-->
                                    <!--<div v-if="editData.rules['01']['04'].checked">-->
                                      <!--<p style="color: #999">差价范围</p>-->
                                      <!--<el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.rules['01']['04'].val"></el-input>-->
                                    <!--</div>-->
                                    <!--/-->
                                    <!--<el-checkbox label="允许低于商品成本单价销售" v-model="editData.rules['01']['05'].checked"></el-checkbox><br/>-->
                                    <!--<div v-if="editData.rules['01']['05'].checked">-->
                                      <!--<p style="color: #999">差价范围</p>-->
                                      <!--<el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.rules['01']['05'].val"></el-input>-->
                                    <!--</div>-->
                                </div>
                                <div v-if="editData.rules['01']['01'].allowYes">
                                  <el-radio-group v-model="editData.rules['01']['01'].val">
                                    <el-radio label="0">无限制条件</el-radio>
                                    <el-radio label="1">有限制条件</el-radio>
                                  </el-radio-group>
                                  <div v-if="editData.rules['01']['01'].val=='1'">
                                    <p style="color: #999">允许低于原价的价差比例</p>
                                    <el-input size="small" placeholder="请填写大于0的数字,不填写表示不限制" class="dg-input" v-model="editData.rules['01']['03'].val"></el-input> %
                                    <p style="color: #999">允许高于原价的价差比例</p>
                                    <el-input size="small" placeholder="请填写大于0的数字,不填写表示不限制" class="dg-input" v-model="editData.rules['01']['04'].val"></el-input> %
                                    <el-checkbox label="不允许低于商品成本单价" v-model="editData.rules['01']['05'].checked"></el-checkbox><br/>
                                    <el-checkbox label="优先按客户上次成交价执行" v-model="editData.rules['01']['02'].checked"></el-checkbox><br/>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="item.code=='02'">
                        <!--留言备注-->
                        <div v-if="editData['r_show_'+item.code]">
                            <div>
                                <span class="subtitle">留言备注</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                                <p>有留言备注的订单是否允许自动审核</p>
                                <div>
                                  <el-checkbox label="允许" v-model="editData.rules['02']['06'].allowYes" @change="allowChange('02','06','yes')"></el-checkbox>
                                  <el-checkbox label="不允许" v-model="editData.rules['02']['06'].allowNo" @change="allowChange('02','06','no')"></el-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="item.code=='03'">
                        <!--支付方式-->
                        <div v-if="editData['r_show_'+item.code]">
                            <div>
                                <span class="subtitle">支付方式</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                                <p>不允许自动审核的支付方式</p>
                                <el-checkbox-group v-model="editData.rules['03']['07'].checkList">
                                  <el-checkbox v-for="(item,item_idx) in data_payType" :key="item_idx"
                                            :label="item.typeId">{{item.name}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="item.code=='04'">
                        <!--商品数量-->
                        <div v-if="editData['r_show_'+item.code]">
                            <div>
                                <span class="subtitle">商品数量</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                                <!--/-->
                                <div>
                                  <p>单个商品购买数量上限</p>
                                  <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.rules['04']['08'].val"></el-input>
                                </div>
                                <!--/-->
                                <div>
                                  <p>购买商品类别数量上限</p>
                                  <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.rules['04']['09'].val"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="item.code=='05'">
                        <!--新客户-->
                        <div v-if="editData['r_show_'+item.code]">
                            <div>
                                <span class="subtitle">新客户</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                                <div>
                                  <p>新客户下单是否允许自动审核</p>
                                  <div>
                                      <el-checkbox label="允许" v-model="editData.rules['05']['10'].allowYes" @change="allowChange('05','10','yes')"></el-checkbox>
                                      <el-checkbox label="不允许" v-model="editData.rules['05']['10'].allowNo" @change="allowChange('05','10','no')"></el-checkbox>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="item.code=='06'">
                        <!--欠款额度-->
                        <div v-if="editData['r_show_'+item.code]">
                            <div>
                                <span class="subtitle">欠款额度</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                                <div>
                                  <p>超过欠款额度的客户订单是否允许自动审核</p>
                                  <div>
                                      <el-checkbox label="允许" v-model="editData.rules['06']['11'].allowYes" @change="allowChange('06','11','yes')"></el-checkbox>
                                      <el-checkbox label="不允许" v-model="editData.rules['06']['11'].allowNo" @change="allowChange('06','11','no')"></el-checkbox>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="item.code=='07'">
                        <!--库存状况-->
                        <div v-if="editData['r_show_'+item.code]">
                            <div>
                                <span class="subtitle">库存状况</span><el-button type="text" @click="removeRule(item.code)">移除</el-button>
                                <!--/-->
                                <div>
                                  <p>低于安全库存量的商品订单是否允许自动审核</p>
                                  <div>
                                      <el-checkbox label="允许" v-model="editData.rules['07']['12'].allowYes" @change="allowChange('07','12','yes')"></el-checkbox>
                                      <el-checkbox label="不允许" v-model="editData.rules['07']['12'].allowNo" @change="allowChange('07','12','no')"></el-checkbox>
                                  </div>
                                </div>
                                <!--/-->
                                <div>
                                  <p>库存为负的商品订单是否允许自动审核</p>
                                  <div>
                                      <el-checkbox label="允许" v-model="editData.rules['07']['13'].allowYes" @change="allowChange('07','13','yes')"></el-checkbox>
                                      <el-checkbox label="不允许" v-model="editData.rules['07']['13'].allowNo" @change="allowChange('07','13','no')"></el-checkbox>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <!--其他-->
                    </div>
                  </div>
                  <!----------------规则 END---------------->
                </el-form-item>
                <!--/-->
                <el-form-item label="权重：">
                  <el-input size="small" placeholder="请输入" class="dg-input" v-model="editData.weight"></el-input>
                  <div class="dg-desc">填写数字越大，代表权重越高，优先级越高</div>
                </el-form-item>
                <!--/-->
                <el-form-item label="描述：">
                    <el-input size="small" type="textarea" placeholder="请填写对订单的简要描述" v-model="editData.description"></el-input>
                </el-form-item>
                <!---->
                <el-form-item label="状态：">
                  <el-radio-group v-model="editData.states">
                    <el-radio label="1">启用</el-radio>
                    <el-radio label="0">停用</el-radio>
                  </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button class="mybtn-blue2" @click="saveDialogData">保存</el-button>
                <el-button @click="editDialogVisible=false">取消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data: function () {
        return {
            // 表格
            main$loading: false,
            main$data: [],
            // 下拉框等数据
            data_OrderAuditType:[],
            data_payType:[],
            data_orderGroup:[], // 订单分组规则
            // 新增、编辑对话框
            editDialogVisible:false,
            editDialogType:'',
            editData:{ }
        }
    },
    methods:{
        fetchData: function () {
            let self = this;

            self.main$loading = true

            self.xFetch.post(self.xApi('/robot/rule/orderaudit/getList'), {

            }).then(function (res) {
                self.main$loading = false

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    self.main$data = [];
                }
                else {
                    self.main$data = res.data.data;
                }
            });
        },
        table_update: function (row) {
            let self = this;

            self.xEui.myloading('加载中...')
            self.xFetch.post(self.xApi('/robot/rule/orderaudit/getDetails'), {
                id:row.id
            },{xPostType:'form'}).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }

                let obj = res.data.data;
                let editData = self.getDefaultEditData();

                editData.id = obj.id;
                editData.name = obj.name;
                editData.groupRule = (obj.groupRule||'').split(',');
                editData.weight = obj.weight;
                editData.description = obj.description;
                editData.states = obj.states + '';
                obj.typeList.forEach(function(item){
                    let code = item.type;

                    // 显示
                    editData['r_show_'+code]=true;

                    // 值
                    item.contentList.forEach(function(chItem){
                        if(chItem.content=='05'){
                          if(chItem.allowed===0){
                            chItem.allowed=1;
                          }else {
                            chItem.allowed=0;
                          }
                        }
//                      console.log(chItem.allowed);
                        try{
                            let define = editData.rules[code][chItem.content];
                            if(define.hasOwnProperty('allowYes')){
                                chItem.allowed == 1
                                    ? define.allowYes = true
                                    : define.allowNo = true;
                                     define.val = chItem.value==-1?'':chItem.value;
                            }
                            else if (define.hasOwnProperty('checked')) {
                                define.checked = chItem.allowed == 1 ? true : false;
                                if (define.hasOwnProperty('val')) {
                                    define.val = chItem.value==-1?'':chItem.value;
                                }
                            }
                            else if(define.hasOwnProperty('checkList')){
                                define.checkList = (chItem.value||'').split(',')
                            }
                            else if(define.hasOwnProperty('val')){
                                define.val = chItem.value==-1?'':chItem.value;
                            }
                        }
                        catch(err) {

                        }
                    });
                });
                // show dialog
                self.editDialogVisible = true;
                self.editDialogType = 'update';
                self.editData = editData;
            });
        },
        table_delete: function (row) {
            let self = this;
            self.xEui.confirm('','确认要删除该条记录吗？',function(){
                self.xEui.myloading('删除中...')
                self.xFetch.post(self.xApi('/robot/rule/orderaudit/delete'), {
                    id:row.id
                },{xPostType:'form'}).then(function (res) {
                    self.xEui.loading_close();

                    if (res.data.code != '00') {
                        self.xEui.msg_error(res.data.text)
                        return
                    }
                    else{
                        self.xEui.msg_success('删除成功')
                        self.fetchData();
                    }
                });
            })
        },
        getDefaultEditData: function(){
            let self = this;
            let editData = {
                groupRule:[], // 订单分组
                states:'1',   // 状态
                rules:{        // 审核规则
                    '01':{     // 商品价格
                        '01':{ allowYes:false,allowNo:false,val:''}, // 允许订单商品实际成交价格与默认销售价格不同
                        '02':{ checked:false},         // 允许按照客户上次成交价执行
                        '03':{ checked:true,val:''}, // 允许低于默认销售价格
                        '04':{ checked:true,val:''}, // 允许高于默认销售价格
                        '05':{ checked:true,val:''}, // 允许低于商品成本单价销售
                    },
                    '02':{     // 留言备注
                        '06':{ allowYes:false,allowNo:false}, // 有留言备注的订单是否允许自动审核
                    },
                    '03':{     // 支付方式
                        '07':{ checkList:[]}, // 不允许自动审核的支付方式
                    },
                    '04':{     // 商品数量
                        '08':{ val:''}, // 单个商品购买数量上限
                        '09':{ val:''}, // 购买商品类别数量上限
                    },
                    '05':{     // 新客户
                        '10':{ allowYes:false,allowNo:false}, // 新客户下单是否允许自动审核
                    },
                    '06':{     // 欠款额度
                        '11':{ allowYes:false,allowNo:false}, // 超过欠款额度的客户订单是否允许自动审核
                    },
                    '07':{     // 库存状况
                        '12':{ allowYes:false,allowNo:false}, // 低于安全库存量的商品订单是否允许自动审核
                        '13':{ allowYes:false,allowNo:false}, // 库存为负的商品订单是否允许自动审核
                    }
                }
            };
            return editData;
        },
        // 已经属于其他审核规则的订单分组不可再选择
        // 此方法用于判断指定的分组是否属于其他审核规则
        isGroupRuleDis: function(orderGorupName,notAuditId){
            let self = this;
            for (let i = 0; i < self.main$data.length; i++) {
                let record = self.main$data[i];

                // 不需要判断的审核规则
                if(record.id == notAuditId)
                    continue;

                let groupsArr = (record.groups||'').split(',')
                if(groupsArr.indexOf(orderGorupName)>=0){
                    return true;
                }
            }
            return false
        },
        // 允许 不允许 发生变化
        allowChange: function(ruleCode,contentCode,type){
            let data = this.editData.rules[ruleCode][contentCode]
            if(type == 'yes' && data.allowYes){
                data.allowNo = false
            }
            else if(type == 'no' && data.allowNo){
                data.allowYes = false
            }
        },
        showAddDialog: function(){
            this.editDialogVisible = true;
            this.editDialogType = 'add';
            this.editData = this.getDefaultEditData();
        },
        selectRule: function(){
            let code = this.editData.OrderAuditType;
            if(code){
                this.$set(this.editData, 'r_show_' + code, true)
            }
        },
        removeRule: function(code){
            this.$set(this.editData, 'r_show_' + code, false)
        },
        saveDialogData: function(){
            let self = this;
            let postData = {
                'id':self.editData.id,
                'name':self.editData.name,
                'groupRule':self.editData.groupRule.join(','),
                'weight':self.editData.weight,
                'description':self.editData.description,
                'states':self.editData.states,
                'typeList':[]
            }

            for (let p in self.editData) {
                if (p.indexOf('r_show_') >= 0 && self.editData[p]) {
                    let code = p.replace('r_show_', '');

                    let contentList = [];
                    for(let con_code in self.editData.rules[code]){
                        let con = self.editData.rules[code][con_code];
                        if(con.hasOwnProperty('allowYes')){
                            if(con.allowYes || con.allowNo){
                                contentList.push({
                                    'content': con_code,
                                    'allowed': con.allowYes?'1':'0',
                                    'value':con.val || ''
                                });
                            }
                        }
                        else if(con.hasOwnProperty('checked')){
                            contentList.push({
                                'content': con_code,
                                'allowed': con.checked?'1':'0',
                                'value':con.val || ''
                            });
                        }
                        else if(con.hasOwnProperty('checkList')){
                            contentList.push({
                                'content': con_code,
                                'value': con.checkList.join(','),
                            });
                        }
                        else if(con.hasOwnProperty('val')){
                            contentList.push({
                                'content': con_code,
                                'value': con.val,
                            });
                        }
                    }
//                    // 商品价格特殊处理
                    if(code == '01'){
                        if(contentList[2].value==''){
                          contentList[2].value=-1
                        }
                        if(contentList[3].value==''){
                          contentList[3].value=-1
                        }
                        if(contentList[4].allowed=='1'){
                          contentList[4].allowed='0'
                        }else if(contentList[4].allowed=='0'){
                          contentList[4].allowed='1'
                        }
                        if(contentList[0].content == '01'){
                            if(contentList[0].allowed == '1'){
                                // 允许价格不同
                              contentList = [contentList[0],contentList[1],contentList[2],contentList[3],contentList[4]];
                            }
                            else{
                                // 不允许价格不同
                              contentList = [contentList[0],contentList[1]];
                            }
                            if(contentList[0].allowed == '1'&&contentList[0].value == '0'){
                              contentList = [contentList[0]];
                            }
                        }
                        else{
                            // 未勾选
                            continue;
                        }
                    }
                    postData.typeList.push({
                        "type": code,
                        "contentList": contentList
                    });
                }
            }

            if(!postData.name){
                self.xEui.msg_error('请输入名称')
                return;
            }

            if(!postData.groupRule){
                self.xEui.msg_error('请选择订单分组')
                return;
            }
            // save
            self.xEui.myloading('保存中...')
            self.xFetch.post(self.xApi(
                    postData.id ? '/robot/rule/orderaudit/update' : '/robot/rule/orderaudit/add'
            ), postData).then(function (res) {
                self.xEui.loading_close();

                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }
                else {
                    self.xEui.msg_success('保存成功')
                    self.editDialogVisible = false;
                    self.fetchData();
                }
            });
        }
    },
    created: function(){
        let self = this;

        // 表格数据
        self.fetchData();

        // 下拉框等数据
        //--订单审核规则类型
        self.xFetch.post(self.xApi('/robot/common/getOrderAuditType'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }

            self.data_OrderAuditType = res.data.data;
        });
        //--支付方式
        self.xFetch.post(self.xApi('/robot/common/getPayType'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            self.data_payType = res.data.data;
        });
        //--订单分组
        self.xFetch.post(self.xApi('/robot/rule/ordergroup/getList'), {}).then(function (res) {
            if (res.data.code != '00') {
                self.xEui.msg_error(res.data.text)
                return
            }
            let list = [];
            res.data.data.forEach(function (item) {
                if (item.app == '1'/*审核*/ || item.app == '3'/*全部*/) {
                    list.push(item)
                }
            });
            self.data_orderGroup = list;
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .el-input, .el-select, .el-date-editor.el-input{
      width: 220px;
    }
    .el-textarea{
      width: 370px;
    }
    /*config-title*/
    .config-title{ font-size: 13px;color: #333;font-weight: 700;padding: 30px 0; }
    /*mydialog_add_order_audit_rule*/
    .mydialog_add_order_audit_rule{ }
    .mydialog_add_order_audit_rule .dg-input{ width: 370px }
    .mydialog_add_order_audit_rule .dg-desc{ font-size: 13px;color: #909399;line-height: 30px }
    p{
      margin: 0;
    }
    .subtitle{
      font-size: 16px;
      font-weight: bold;
      margin-right: 20px;
    }
</style>
<style>
    /*mydialog_add_order_audit_rule*/
    .mydialog_add_order_audit_rule .el-dialog__body{ padding: 20px;padding-bottom: 0 }
    .mydialog_add_order_audit_rule .el-form-item{ margin-bottom: 10px }
</style>



// WEBPACK FOOTER //
// src/views/config/strategy/order-audit-rule.vue